import React, { Component } from 'react';
import  ReactDom from 'react-dom';
import { HashRouter, Route } from 'react-router-dom'
import { createHashHistory } from "history";
import CarouselPage from './pages/carouselPage'
import Home from './pages/home'
import Productions from './pages/productions'
import AboutUs from './pages/aboutUs'
import CorporationCase from './pages/CorporationCase'
import Download from './pages/download'
import logo from './images/logo.png';
import smallLogo from './images/smallLogo.jpg'
import './less/index.less';
import 'antd/dist/antd.less';

const customHistory = createHashHistory();

class App extends Component {
    constructor(props) {
		super(props)
		this.state = {
            headList: ['首页','产品介绍','下载中心','公司案例','关于我们'],
            seletedIndex: 0,
            hashRouters: ['','productions','download','corporationCase','aboutUs']
        }
	}

    navigate(indx) {
        const { hashRouters } = this.state;
        this.props.history.push(`/${hashRouters[indx]}`)
        this.setState({
            seletedIndex: indx
        })
    }

    render() {
        const { headList, seletedIndex } = this.state;
        return (
            <div>
                <div className="header">
                    <img src={logo} className="headerImg"/>
                    <ul>
                        {
                            headList.map((item,indx) => {
                                return <li 
                                        className={seletedIndex===indx?"selectedColor navigation":"navigation"}
                                        onClick={this.navigate.bind(this,indx)} 
                                        key={indx}>
                                            {item}
                                        </li>
                            })
                        }
                    </ul>
                    <img src={smallLogo} /><a href="http://cm.sjychina.com/" target="_blank">快递管理平台入口</a>
                </div>
                <CarouselPage/>
                <div className="content">
                    <HashRouter >
                        <div>
                            <Route path='/' exact component={Home}/>
                            <Route path='/productions' component={Productions}/>
                            <Route path='/aboutUs' component={AboutUs}/>
                            <Route path='/corporationCase' component={CorporationCase}/>
                            <Route path='/download' component={Download}/>
                        </div>
                    </HashRouter>
                </div>
                <div className="footer">
                    <div className="footer1">
                        <a href="https://beian.miit.gov.cn" target="_blank">浙ICP备17009926号-{window.location.host=='www.sjychina.com'?1:2}</a>2016-2021 杭州十间鱼科技 All Rights Reserved.
                    </div>
                    <div className="footer2">
                        <span>企业简介</span>
                        <span>产品介绍</span>
                        <span>联系我们</span>
                    </div>
                </div>
            </div>
            
        )
    }
}

ReactDom.render(<App history={customHistory}/>, document.getElementById('app'))
